var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        {
          staticClass: "container__create__user",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            }
          }
        },
        [
          _c("h3", { staticClass: "stepper__title gray" }, [
            _vm._v("Crear el usuario para la Plataforma Administrativa")
          ]),
          _c("p", { staticClass: "installation__schedule__subtitle" }, [
            _vm._v(
              "Con estos datos crearemos el usuario para acceder a la plataforma administrativa en la cual se podrá hacer el seguimiento en línea de ventas."
            )
          ]),
          _c(
            "v-flex",
            { staticClass: "checkbox__centered" },
            [
              _c(
                "v-layout",
                { attrs: { row: "", "fill-height": "" } },
                [
                  _c("v-checkbox", {
                    attrs: { "input-value": "true", color: "orange" },
                    on: { change: _vm.loadLegalRepresentativeData },
                    model: {
                      value: _vm.dataLegal,
                      callback: function($$v) {
                        _vm.dataLegal = $$v
                      },
                      expression: "dataLegal"
                    }
                  }),
                  _c("h4", [_vm._v("Utilizar datos del representante legal")])
                ],
                1
              )
            ],
            1
          ),
          _c("v-text-field", {
            staticClass: "style-stepped mt-4",
            attrs: {
              label: "Nombres y Apellidos",
              type: "text",
              "name.trim": "userName",
              disabled: _vm.sending,
              error: _vm.$v.userName.$error,
              "error-messages": _vm.userNameErrorMessages,
              maxlength: 50
            },
            on: {
              input: function($event) {
                _vm.$v.userName.$touch()
              },
              keypress: _vm.onlyLetters
            },
            model: {
              value: _vm.userName,
              callback: function($$v) {
                _vm.userName = $$v
              },
              expression: "userName"
            }
          }),
          _c("email-autocomplete", {
            staticClass: "style-stepped",
            attrs: {
              label: "Correo de usuario",
              type: "email",
              "name.trim": "userEmail",
              stepper: true,
              disabled: _vm.sending,
              error: _vm.$v.userEmail.$error,
              "error-messages": _vm.userEmailErrorMessages,
              withErrors: true,
              maxlength: 40
            },
            on: {
              input: function($event) {
                _vm.$v.userEmail.$touch()
              }
            },
            model: {
              value: _vm.userEmail,
              callback: function($$v) {
                _vm.userEmail = $$v
              },
              expression: "userEmail"
            }
          }),
          _c("v-text-field", {
            staticClass: "style-stepped",
            attrs: {
              label: "Teléfono de Usuario",
              type: "text",
              "name.trim": "userPhone",
              disabled: _vm.sending,
              error: _vm.$v.userPhone.$error,
              "error-messages": _vm.userPhoneErrorMessages,
              maxLength: 20
            },
            on: {
              input: function($event) {
                _vm.$v.userPhone.$touch()
              },
              keypress: _vm.onlyNumbers
            },
            model: {
              value: _vm.userPhone,
              callback: function($$v) {
                _vm.userPhone = $$v
              },
              expression: "userPhone"
            }
          }),
          _c(
            "v-layout",
            { staticClass: "mt-2", attrs: { "justify-center": "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "primary-button",
                  attrs: {
                    disabled: _vm.sending || _vm.$v.$invalid,
                    type: "submit"
                  }
                },
                [_vm._v("Continuar")]
              )
            ],
            1
          ),
          _c(
            "v-layout",
            {
              staticClass: "hidden-sm-and-down",
              attrs: { "justify-center": "" }
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "primary-button text black uppercase",
                  attrs: { small: "" },
                  on: {
                    click: function($event) {
                      _vm.changeStep(false)
                    }
                  }
                },
                [_vm._v("Atrás")]
              )
            ],
            1
          ),
          _c("loader", {
            ref: "loaderModal",
            attrs: { text: "Realizando validación" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14d78d8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d78d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/register-plataform.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-14d78d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/register-plataform.vue
// module chunks = 0 1 2 3